import classNames from "classnames";
import PropTypes from "prop-types";
import { useEffect } from "react";
import styles from "./modal.module.scss";
import ModalBody from "./ModalBody";
import ModalHeader from "./ModalHeader";
import ModalTitle from "./ModalTitle";

const Modal = (props: any) => {
  const {
    dialogClassName, className, style, backdropClassName, contentClassName, children, onHide,
    view,
  } = props;

  const modalStyle = { display: "block", ...style };

  useEffect(() => {
    // lock scroll
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    document.body.style.position = "fixed";
    document.body.style.width = "100%";

    return () => {
      document.body.style.overflow = originalOverflow;
      document.body.style.position = "";
      document.body.style.width = "";
    };
  }, []);

  const handleOutsideClick = (e: any) => {
    // When clicked outside the modal area, click is triggered on element with class modal
    if (e.target.matches(".modal")) {
      onHide();
    }
  };

  const handleEscKey = (event: any) => {
    // Escape key code = 27
    if (event.keyCode !== 27) {
      return;
    }
    onHide();
  };

  return (
    <div
      tabIndex="-1"
      role="dialog"
      onKeyDownCapture={handleEscKey}
      onMouseDownCapture={handleOutsideClick}
    >

      <div className={classNames("modal-backdrop", backdropClassName,
        {
          [styles.backdrop]: !backdropClassName,
        })}
      />

      <div
        tabIndex="-1"
        role="dialog"
        style={modalStyle}
        className={classNames("modal", className, styles.modal_dialog)}
      >

        <div className={classNames(`modal-dialog ${dialogClassName}`, {
          [styles.animate]: !view,
          [styles.animate_bottom]: view === "fromBottom",
          [styles.animate_from_right]: view === "fromRight",
        })}
        >

          <div
            className={classNames(`modal-content ${contentClassName}`, {
              [styles.modal_content_bottomsheet]: view === "fromBottom",
            })}
            role="document"
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

Modal.propTypes = {
  className: PropTypes.string.isRequired,
  dialogClassName: PropTypes.string.isRequired,
  backdropClassName: PropTypes.any.isRequired,
  onHide: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

Modal.Body = ModalBody;
Modal.Header = ModalHeader;
Modal.Title = ModalTitle;

export default Modal;
